/* UK presentation layer. Generation, saved portraits and cart submissions use the existing theme engine. */
(() => {
  const start = () => {
    const root = document.querySelector('[data-uk-portrait]');
    if (!root || root.dataset.initialized) return Boolean(root?.dataset.initialized);
    const composer = document.querySelector('.gemini-transformer');
    const legacy = composer?.closest('.product-single');
    const form = document.querySelector('form[id^="AddToCartForm--"]');
    const master = form?.querySelector('select[name="id"]');
    const nativeOrder = form?.querySelector('button[name="add"]');
    if (!composer || !legacy || !form || !master || !nativeOrder) return;
    let product;
    try { product = JSON.parse(root.querySelector('[data-uk-product]').textContent); } catch (_) { return; }
    const variants = product.variants;
    const $ = selector => root.querySelector(selector);
    const file = composer.querySelector('input[type="file"]');
    const generate = composer.querySelector('.gemini-transformer__button');
    const order = $('[data-uk-order]');
    const reviewCount = $('[data-uk-review-count]');
    if (reviewCount && Number(reviewCount.textContent) > 0) reviewCount.textContent = Number(reviewCount.textContent).toLocaleString('en-GB');
    const urlInput = () => form.querySelector('input[name="properties[Portrait URL]"]');
    const canvas = v => /^canvas/i.test(v.options[0]);
    const finishOf = v => canvas(v) ? 'canvas' : /black/i.test(v.options[1]) ? 'black' : /white/i.test(v.options[1]) ? 'white' : /natural|wood/i.test(v.options[1]) && !/no frame/i.test(v.options[1]) ? 'natural' : 'none';
    const sizeOf = v => canvas(v) && /30\s*[x×]\s*40\s*cm/i.test(v.options[0]) ? '30X40' : (v.options[0].match(/A[234]/i) || [v.options[0]])[0].toUpperCase();
    const names = {canvas:'Canvas',none:'Print only',black:'Black frame',white:'White frame',natural:'Natural wood'};
    const frameKeys = ['black','white','natural'];
    const familyOf = key => frameKeys.includes(key) ? 'framed' : key;
    const dimensions = {A4:'21 × 29.7 cm',A3:'29.7 × 42 cm',A2:'42 × 59.4 cm','30X40':'30 × 40 cm'};
    const sizeNames = {A4:'Small',A3:'Medium',A2:'Large','30X40':'Large'};
    const money = variant => variant?.money.replace(/<[^>]*>/g,'') || 'Unavailable';
    let selected = variants.find(v => String(v.id) === String(product.selectedId)) || variants.find(v => v.available);
    let finish = finishOf(selected), size = sizeOf(selected), demo = false, portrait = '', syncing = false;
    let readyIdentity = '', readyRevision = 0, interactionRevision = 0, restoringVariant = null;
    const express = $('[data-uk-express]');
    const expressVariant = $('[data-uk-express-variant]'), expressArtwork = $('[data-uk-express-artwork]');
    function syncExpress() {
      if (!express || !expressVariant || !expressArtwork) return false;
      const ready = root.dataset.view === 'ready' && root.dataset.settled === 'true' && !root.dataset.revealing && root.dataset.ukBusy !== 'true' && !demo && /^https:\/\//i.test(portrait) && selected?.available && !nativeOrder.disabled && master.value === String(selected.id) && urlInput()?.value === portrait;
      const changed = expressVariant.value !== String(selected.id);
      const artworkChanged = expressArtwork.value !== (ready ? portrait : '');
      expressVariant.value = String(selected.id);
      expressArtwork.value = ready ? portrait : '';
      expressVariant.disabled = !ready; expressArtwork.disabled = !ready;
      express.hidden = !ready; express.inert = !ready;
      if (changed) expressVariant.dispatchEvent(new Event('change', {bubbles:true}));
      if (artworkChanged) expressArtwork.dispatchEvent(new Event('change', {bubbles:true}));
      return ready;
    }
    if (express) {
      const guard = event => {
        if (!syncExpress()) { event.preventDefault(); event.stopImmediatePropagation(); }
      };
      express.addEventListener('click', guard, true);
      express.querySelector('form').addEventListener('submit', guard, true);
      new MutationObserver(syncExpress).observe(root, {attributes:true,attributeFilter:['data-view','data-settled','data-revealing','data-uk-busy']});
      new MutationObserver(syncExpress).observe(nativeOrder, {attributes:true,attributeFilter:['disabled']});
    }
    let savedEntryPending = Boolean(window.BellissimaPortraitEntry?.saved);
    // Delayed presentation must never pull a customer back after they interact.
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
      document.addEventListener(type, () => { interactionRevision++; }, {passive:true});
    });
    const twoFrames = () => new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    async function bounded(work, milliseconds = 15000) {
      let timer;
      try {
        return await Promise.race([work, new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Portrait display did not finish loading')), milliseconds); })]);
      } finally { clearTimeout(timer); }
    }
    async function settlePresentation(image) {
      const fonts = document.fonts;
      if (!image) throw new Error('Portrait image is unavailable');
      let loaded, failed;
      try {
        await bounded(Promise.all([
          image.decode ? image.decode() : new Promise((resolve, reject) => {
            loaded = resolve; failed = reject;
            image.addEventListener('load', loaded, {once:true});
            image.addEventListener('error', failed, {once:true});
            if (image.complete) image.naturalWidth ? resolve() : reject(new Error('Portrait image could not load'));
          }),
          fonts?.load ? Promise.all([
          fonts.load('700 34px Lora'), fonts.load('400 44px Lora'),
          fonts.load('400 17px "Source Sans 3"'), fonts.load('600 18px "Source Sans 3"'), fonts.load('700 17px "Source Sans 3"')
          ]) : Promise.resolve()
        ]));
      } finally {
        if (loaded) image.removeEventListener('load', loaded);
        if (failed) image.removeEventListener('error', failed);
      }
      await twoFrames();
      const stage = image?.closest('[data-pop-ready-preview]');
      if (stage && stage.dataset.finish !== 'none') {
        // Observe the existing renderer; never create a second canvas or image pipeline.
        let observer, resize;
        const rendered = () => stage.clientWidth > 0 && stage.clientHeight > 0 && stage.classList.contains('pop-canvas-rendered');
        try {
          await bounded(new Promise(resolve => {
            const check = () => { if (rendered()) resolve(); };
            observer = new MutationObserver(check);
            observer.observe(stage, {attributes:true, attributeFilter:['class']});
            resize = new ResizeObserver(check); resize.observe(stage);
            check();
          }));
        } finally { observer?.disconnect(); resize?.disconnect(); }
      }
      await twoFrames();
    }
    const preferredSmallPrint = variants.find(v => finishOf(v) === 'none' && sizeOf(v) === 'A4' && v.available);
    if (!new URLSearchParams(location.search).has('variant') && preferredSmallPrint) {
      selected = preferredSmallPrint; finish = finishOf(selected); size = sizeOf(selected);
    }
    let preferredFrame = frameKeys.includes(finish) ? finish : frameKeys.find(key => variants.some(v => finishOf(v) === key && v.available));
    const engineMount = document.createElement('span');
    engineMount.hidden = true; engineMount.setAttribute('data-uk-engine-mount', '');
    composer.before(engineMount);
    $('[data-uk-composer-mount]').appendChild(composer);
    // Progress must survive hiding the upload/composer during the ready handoff.
    const progress = composer.querySelector('.gemini-transformer__modal');
    if (progress) root.appendChild(progress);
    // Match Pop Prints: the existing progress surface owns scroll and background focus.
    let progressLocked = false, progressOwnsScrollLock = false, managedInert = [];
    function lockProgress() {
      if (!progress || progressLocked) return;
      progressLocked = true;
      const html = document.documentElement;
      progressOwnsScrollLock = !html.hasAttribute('scroll-lock');
      if (progressOwnsScrollLock) html.setAttribute('scroll-lock', '');
      html.classList.add('uk-portrait-progress-open');
      let branch = progress;
      while (branch && branch !== document.body) {
        const parent = branch.parentElement;
        if (!parent) break;
        [...parent.children].forEach(sibling => {
          if (sibling === branch || sibling.hasAttribute('inert')) return;
          sibling.setAttribute('inert', ''); managedInert.push(sibling);
        });
        branch = parent;
      }
    }
    function unlockProgress() {
      managedInert.forEach(element => { if (element.isConnected) element.removeAttribute('inert'); });
      managedInert = []; progressLocked = false;
      document.documentElement.classList.remove('uk-portrait-progress-open');
      if (progressOwnsScrollLock) document.documentElement.removeAttribute('scroll-lock');
      progressOwnsScrollLock = false;
    }
    root.ukPortraitGate = window.BellissimaPortraitGate?.create({root,composer,progress,file,state:() => ({variantId:String(selected.id)})});
    if (root.dataset.emailGateRequired === 'true' && !root.ukPortraitGate) {
      if (file) file.disabled = true;
      if (generate) generate.disabled = true;
      const message = composer.querySelector('.gemini-transformer__status');
      if (message) { message.hidden = false; message.textContent = 'The preview form could not load. Please reload this page to try again.'; message.classList.add('gemini-transformer__status--error'); }
    }
    root.addEventListener('uk:portrait-progress-open', lockProgress);
    root.addEventListener('uk:portrait-gate-open', lockProgress);
    root.addEventListener('uk:portrait-progress-close', unlockProgress);
    legacy.classList.add('uk-portrait-legacy');
    legacy.setAttribute('aria-hidden', 'true');
    root.hidden = false;
    const uploadLabel = composer.querySelector('.gemini-transformer__label--upload');
    const compactHero = root.classList.contains('uk-portrait--cta-preview');
    const uploadActionText = String(product.id) === '15434210017658' ? 'Create My Pet Portrait' : 'Create My Free Preview';
    let mobileUploadText, syncUploadName;
    if (uploadLabel && file) {
      [...uploadLabel.childNodes].filter(n => n.nodeType === 3).forEach(n => n.remove());
      const labelText = document.createElement('span');
      labelText.textContent = uploadActionText;
      const arrow = document.createElementNS('http://www.w3.org/2000/svg','svg');
      arrow.setAttribute('class','personalisation-upload-button__arrow');
      arrow.setAttribute('viewBox','0 0 24 24');
      arrow.setAttribute('aria-hidden','true');
      arrow.setAttribute('focusable','false');
      const arrowPath = document.createElementNS('http://www.w3.org/2000/svg','path');
      arrowPath.setAttribute('d','M4 12h15M13 5l7 7-7 7');
      arrow.appendChild(arrowPath);
      uploadLabel.prepend(labelText,arrow);
      file.setAttribute('aria-label', uploadActionText);
      if (compactHero) {
        labelText.classList.add('uk-portrait__desktop-upload-text');
        mobileUploadText = document.createElement('span');
        mobileUploadText.className = 'uk-portrait__mobile-upload-text';
        mobileUploadText.textContent = uploadActionText;
        const camera = document.createElementNS('http://www.w3.org/2000/svg','svg');
        camera.setAttribute('class','uk-portrait__upload-camera');
        camera.setAttribute('viewBox','0 0 24 24');
        camera.setAttribute('aria-hidden','true');
        camera.innerHTML = '<path d="M21 19H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z"/><circle cx="12" cy="12" r="4"/>';
        uploadLabel.prepend(camera,mobileUploadText);
        const dock = document.createElement('div');
        dock.className = 'uk-portrait__upload-dock';
        uploadLabel.before(dock);
        dock.appendChild(uploadLabel);
        const reassurance = document.createElement('p');
        reassurance.className = 'uk-portrait__dock-reassurance';
        reassurance.innerHTML = '<span>✓ No card needed</span><span>✓ No obligation to buy</span>';
        dock.appendChild(reassurance);
        const mobile = matchMedia('(max-width:767px)');
        syncUploadName = () => file.setAttribute('aria-label', mobile.matches ? mobileUploadText.textContent : labelText.textContent);
        mobile.addEventListener('change', syncUploadName);
        syncUploadName();
        const heroCount = $('[data-uk-hero-review-count]');
        if (heroCount) heroCount.textContent = Number(heroCount.textContent).toLocaleString('en-GB');
        // Keep the original file input and its generation flow authoritative.
        const stickyUpload = document.createElement('div');
        stickyUpload.className = 'uk-portrait__sticky-upload';
        stickyUpload.hidden = true;
        const stickyButton = document.createElement('button');
        stickyButton.type = 'button';
        stickyButton.className = 'uk-portrait__sticky-upload-button';
        const stickyText = document.createElement('span');
        stickyText.textContent = uploadActionText;
        stickyButton.append(stickyText, arrow.cloneNode(true));
        stickyUpload.appendChild(stickyButton);
        root.appendChild(stickyUpload);
        let stickyFrame = 0;
        const syncStickyUpload = () => {
          stickyFrame = 0;
          const unavailable = root.hidden || root.dataset.view !== 'upload' ||
            root.dataset.ukBusy === 'true' || root.dataset.revealing || root.dataset.emailGated === 'true' ||
            progressLocked || progress?.classList.contains('is-open') ||
            document.documentElement.classList.contains('uk-portrait-progress-open') ||
            file.disabled || file.closest('[inert]') || !uploadLabel.getClientRects().length;
          stickyUpload.hidden = Boolean(unavailable) || uploadLabel.getBoundingClientRect().bottom > 0;
          stickyButton.disabled = Boolean(unavailable);
        };
        const queueStickyUpload = () => {
          if (!stickyFrame) stickyFrame = requestAnimationFrame(syncStickyUpload);
        };
        stickyButton.addEventListener('click', () => {
          syncStickyUpload();
          if (!stickyUpload.hidden && !stickyButton.disabled) file.click();
        });
        window.addEventListener('scroll', queueStickyUpload, {passive:true});
        window.addEventListener('resize', queueStickyUpload, {passive:true});
        window.addEventListener('pageshow', queueStickyUpload);
        new ResizeObserver(queueStickyUpload).observe(uploadLabel);
        new MutationObserver(queueStickyUpload).observe(root, {attributes:true,attributeFilter:['hidden','data-view','data-uk-busy','data-revealing','data-email-gated']});
        new MutationObserver(queueStickyUpload).observe(file, {attributes:true,attributeFilter:['disabled']});
        new MutationObserver(queueStickyUpload).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
        if (progress) new MutationObserver(queueStickyUpload).observe(progress, {attributes:true,attributeFilter:['class']});
        queueStickyUpload();
      }
    }
    const styleNames = String(product.id) === '15434210017658'
      ? ['Floral','Impasto','Pencil','Watercolour']
      : ['Floral','Painted','Impasto','Pencil','Watercolour'];
    let examples = [];
    try { examples = JSON.parse($('[data-uk-examples]')?.textContent || '[]'); } catch (_) {}
    let demoArtwork = examples[0]?.after || product.example;
    let exampleRequest = 0;
    const exampleCache = new Map();
    function loadExampleImage(src) {
      if (!exampleCache.has(src)) exampleCache.set(src, new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = () => { exampleCache.delete(src); reject(new Error('Example image could not be loaded')); };
        img.src = src;
      }));
      return exampleCache.get(src);
    }
    function selectExample(index) {
      const example = examples[index];
      if (!example || !$('[data-uk-before]')) return;
      const request = ++exampleRequest;
      const comparison = $('[data-uk-comparison]');
      comparison.setAttribute('aria-busy','true');
      const error = $('[data-uk-example-error]');
      if (error) error.hidden = true;
      const hasBefore = Boolean(example.before);
      // Apply each example together so rapid style clicks cannot mix different portraits.
      Promise.all([hasBefore ? loadExampleImage(example.before) : Promise.resolve(),loadExampleImage(example.after)]).then(() => {
        if (request !== exampleRequest) return;
        if (hasBefore) {
          $('[data-uk-before]').src = example.before;
          $('[data-uk-before]').alt = `Example pet photo before the ${example.name.toLowerCase()} portrait`;
        }
        $('.uk-portrait__before').hidden = !hasBefore;
        $('.pop-reassurance-example__arrow').hidden = !hasBefore;
        $('.uk-portrait__after figcaption').textContent = hasBefore ? 'Your portrait' : 'Style example';
        comparison.dataset.exampleOnly = String(!hasBefore);
        $('[data-uk-example]').src = example.after;
        $('[data-uk-example]').alt = `Example ${example.name.toLowerCase()} pet portrait on canvas`;
        comparison.setAttribute('aria-label', hasBefore ? `${example.name} photo-to-portrait example` : `${example.name} portrait example`);
        root.dataset.exampleStyle = example.name;
        demoArtwork = example.after;
      }).catch(() => {
        if (request !== exampleRequest) return;
        if (error) { error.textContent = 'Example unavailable — please try this style again.'; error.hidden = false; }
      }).finally(() => { if (request === exampleRequest) comparison.setAttribute('aria-busy','false'); });
    }
    const styleButtons = [...composer.querySelectorAll('.gemini-transformer__styles .gemini-style')];
    root.dataset.styleCount = String(styleButtons.length);
    if (compactHero && styleButtons.length) {
      const stylesHeading = composer.querySelector('.gemini-transformer__styles')?.previousElementSibling;
      if (stylesHeading?.classList.contains('gemini-transformer__label')) {
        stylesHeading.classList.add('uk-portrait__styles-heading');
        stylesHeading.innerHTML = '<span class="uk-portrait__desktop-styles-text">Choose a style</span><span class="uk-portrait__mobile-styles-text">Choose a style</span><small>Swipe for more →</small>';
        const dock = composer.querySelector('.uk-portrait__upload-dock');
        if (dock) stylesHeading.before(dock);
        // Account for the real header and returning visitors' saved-design bars.
        // Only the first screen changes size; retain the existing input/style nodes.
        const syncHeroTop = () => {
          if (root.dataset.view !== 'upload') return;
          const top = Math.max(0, Math.round(root.getBoundingClientRect().top + window.scrollY));
          const value = `${top}px`;
          if (root.style.getPropertyValue('--uk-hero-document-top') !== value) root.style.setProperty('--uk-hero-document-top', value);
        };
        syncHeroTop();
        window.addEventListener('resize', syncHeroTop, {passive:true});
        window.addEventListener('load', syncHeroTop, {once:true});
        new ResizeObserver(syncHeroTop).observe(document.body);
      }
    }
    styleButtons.forEach((button, index) => {
      button.setAttribute('aria-label', styleNames[index] || `Style ${index + 1}`);
      const example = examples[index];
      if (example && button.querySelector('img')) {
        button.querySelector('img').src = example.after;
        button.querySelector('img').alt = `${example.name} portrait style`;
      }
      if (compactHero) {
        const caption = document.createElement('small');
        caption.className = 'uk-portrait__style-caption';
        caption.textContent = styleNames[index] || `Style ${index + 1}`;
        button.appendChild(caption);
      }
      button.addEventListener('click', () => {
        if (mobileUploadText) {
          mobileUploadText.textContent = uploadActionText;
          syncUploadName();
          if (matchMedia('(max-width:767px)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) uploadLabel.animate([{transform:'scale(1)'},{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:400});
        }
        if (example) { selectExample(index); return; }
        const src = button.querySelector('img')?.getAttribute('src');
        if (src) $('[data-uk-example]').src = src;
      });
    });
    if (examples.length) {
      root.dataset.exampleStyle = examples[0].name;
      const initiallySelected = styleButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      if (initiallySelected > 0) selectExample(initiallySelected);
    }
    if (!examples.length) $('[data-uk-example]').addEventListener('error', function () {
      if (this.getAttribute('src') !== product.example) this.src = product.example;
    });
    function chooseVariant(nextFinish, nextSize) {
      const matches = variants.filter(v => finishOf(v) === nextFinish);
      return matches.find(v => sizeOf(v) === nextSize && v.available) || matches.find(v => v.available) || matches[0];
    }
    function syncNative() {
      if (restoringVariant) {
        selected = restoringVariant; finish = finishOf(selected); size = sizeOf(selected);
        if (frameKeys.includes(finish)) preferredFrame = finish;
      }
      if (!selected || syncing) return false;
      const controls = selected.options.map((value, i) => {
        const select = form.querySelector(`select[data-index="option${i + 1}"]`);
        if (select) return [...select.options].some(option => option.value === value) ? {select, value} : null;
        const radios = [...form.querySelectorAll(`[data-index="option${i + 1}"] input[type="radio"],input[data-index="option${i + 1}"]`)];
        const checked = radios.find(input => input.value === value);
        return checked ? {radios, checked} : null;
      });
      if (controls.some(control => !control) || ![...master.options].some(option => option.value === String(selected.id))) {
        $('[data-uk-order-status]').textContent = 'This option is unavailable. Please choose another size or finish.';
        return false;
      }
      syncing = true;
      try {
        // Commit the complete existing Shopify option tuple before any listener reads it.
        controls.forEach(({select, value, radios, checked}) => {
          if (select) select.value = value;
          else radios.forEach(input => { input.checked = input === checked; });
        });
        master.value = String(selected.id);
        // One notification sees the final tuple, avoiding intermediate variant/image renders.
        const first = controls[0];
        (first.select || first.checked).dispatchEvent(new Event('change', {bubbles:true}));
        master.dispatchEvent(new Event('change', {bubbles:true}));
        return true;
      } finally { syncing = false; }
    }
    function choiceButton(label, active, disabled, click) {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'uk-portrait__choice';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(active)); button.disabled = disabled || root.dataset.ukBusy === 'true';
      const title = document.createElement('strong'); title.textContent = label; button.appendChild(title);
      button.addEventListener('click', click);
      return button;
    }
    function render() {
      const finishMount = $('[data-uk-finishes]'); finishMount.replaceChildren();
      [{key:'none',label:'Print'},{key:'canvas',label:'Canvas'},{key:'framed',label:'Framed'}].forEach(({key,label}) => {
        const matching = variants.filter(v => familyOf(finishOf(v)) === key);
        if (!matching.length) return;
        const button = choiceButton(label, key === familyOf(finish), !matching.some(v => v.available), () => {
          selected = chooseVariant(key === 'framed' ? preferredFrame : key, size);
          finish = finishOf(selected); size = sizeOf(selected); syncNative(); render();
        });
        const available = matching.filter(v => v.available);
        const cheapest = (available.length ? available : matching).reduce((a,b) => a.price < b.price ? a : b);
        const from = document.createElement('span'); from.className = 'uk-portrait__finish-price'; from.textContent = `From ${money(cheapest)}`;
        button.appendChild(from); finishMount.appendChild(button);
      });
      const frameMount = $('[data-uk-frames]'); frameMount.replaceChildren();
      $('[data-uk-frame-options]').hidden = familyOf(finish) !== 'framed';
      frameKeys.forEach(key => {
        const matching = variants.filter(v => finishOf(v) === key);
        if (!matching.length) return;
        const button = choiceButton(names[key], key === finish, !matching.some(v => v.available), () => {
          preferredFrame = key; selected = chooseVariant(key, size);
          finish = finishOf(selected); size = sizeOf(selected); syncNative(); render();
        });
        const swatch = document.createElement('span'); swatch.className = 'uk-portrait__swatch'; swatch.dataset.swatch = key; swatch.setAttribute('aria-hidden','true');
        button.prepend(swatch); frameMount.appendChild(button);
      });
      const sizeMount = $('[data-uk-sizes]'); sizeMount.replaceChildren();
      const possible = [...new Set(variants.filter(v => finishOf(v) === finish).map(sizeOf))];
      possible.forEach(key => {
        const matching = variants.filter(v => finishOf(v) === finish && sizeOf(v) === key);
        const variant = matching.find(v => v.available) || matching[0];
        const displayName = sizeNames[key] || key;
        const button = choiceButton(displayName, key === size, !variant?.available, () => { selected = variant; size = key; syncNative(); render(); });
        button.dataset.size = key;
        const dimensionsLabel = document.createElement('span'); dimensionsLabel.className = 'uk-portrait__size-dimensions'; dimensionsLabel.textContent = key === '30X40' ? dimensions[key] : dimensions[key] ? `${key} · ${dimensions[key]}` : variant.options[0]; button.appendChild(dimensionsLabel);
        const price = document.createElement('span'); price.className = 'uk-portrait__size-price'; price.textContent = money(variant); button.appendChild(price);
        if (displayName === 'Large' && variant?.available) {
          const badge = document.createElement('span'); badge.className = 'uk-portrait__popular'; badge.textContent = 'Most popular'; button.appendChild(badge);
        }
        sizeMount.appendChild(button);
      });
      const inclusions = finish === 'canvas'
        ? ['Premium canvas', 'Solid 2 cm wooden frame', 'Hanging kit included']
        : finish === 'none'
          ? ['Premium art print']
          : ['Premium art print', 'Beautifully framed', 'Ready to hang'];
      $('[data-uk-inclusion]').replaceChildren(...inclusions.map(text => {
        const item = document.createElement('li'); item.textContent = text; return item;
      }));
      $('[data-uk-summary-finish]').textContent = finish === 'none' ? 'Print' : names[finish];
      $('[data-uk-summary-choice]').textContent = `${sizeNames[size] || size} · ${size === '30X40' ? dimensions[size] : size}`;
      $('[data-uk-total]').textContent = money(selected);
      const orderLabel = $('[data-uk-order-label]');
      if (orderLabel) orderLabel.textContent = `Add to basket – ${money(selected)}`;
      root.querySelectorAll('[data-uk-art-stage]').forEach(stage => {
        stage.dataset.finish = finish;
        const ratio = size === '30X40' ? '3 / 4' : '21 / 29.7';
        stage.style.setProperty('--pop-canvas-ratio', ratio);
        stage.style.setProperty('--pop-portrait-ratio', ratio);
      });
      order.hidden = demo; $('[data-uk-demo-upload]').hidden = !demo; $('[data-uk-demo-note]').hidden = !demo;
      order.disabled = demo || !portrait || !selected.available || root.dataset.settled === 'false' || root.dataset.ukBusy === 'true';
      root.dataset.variantId = String(selected.id);
      syncExpress();
    }
    function positionAtTop() {
      const html = document.documentElement, behavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo({top:0, left:0, behavior:'instant'});
      html.style.scrollBehavior = behavior;
    }
    async function showReady(isDemo = false, source = savedEntryPending ? 'saved-entry' : 'generated') {
      const raw = urlInput()?.value || '';
      if (!isDemo && !/^https?:\/\//i.test(raw)) return;
      const identity = isDemo ? `demo:${demoArtwork}` : `portrait:${raw}`;
      if (root.dataset.view === 'ready' && readyIdentity === identity) return;
      readyIdentity = identity;
      const revision = ++readyRevision, interaction = interactionRevision;
      savedEntryPending = false;
      demo = isDemo; portrait = isDemo ? '' : raw;
      if (source !== 'amended') root.dataset.revealing = 'true';
      root.dataset.settled = 'false';
      delete root.dataset.displayError;
      root.querySelectorAll('[data-uk-art]').forEach(img => {
        const src = isDemo ? demoArtwork : raw;
        if (img.getAttribute('src') !== src) img.src = src;
      });
      root.dataset.view = 'ready'; $('.uk-portrait__upload').hidden = true; $('.uk-portrait__ready').hidden = false;
      syncNative(); render();
      if (!isDemo && ['generated','email-pending'].includes(source) && root.dataset.emailGateRequired === 'true') {
        // Gate the authoritative finished artwork before decorative canvas/font rendering.
        // A display timeout must not discard the held portrait or interrupt email entry.
        window.BellissimaPortraitEntry?.finish();
        if (!root.ukPortraitGate) return;
        await root.ukPortraitGate.wait(raw, source);
        if (revision !== readyRevision || root.dataset.view !== 'ready' || readyIdentity !== identity) return;
      }
      try {
        await Promise.all([...root.querySelectorAll('[data-uk-art]')].map(settlePresentation));
      } catch (_) {
        if (revision !== readyRevision || readyIdentity !== identity) return;
        // Preserve the saved artwork and cart URL; a display failure must not cause a new generation.
        readyIdentity = ''; root.dataset.displayError = 'true';
        delete root.dataset.revealing; delete root.dataset.settled;
        root.dataset.view = 'upload'; $('.uk-portrait__upload').hidden = false; $('.uk-portrait__ready').hidden = true;
        composer.classList.remove('gemini-transformer--hidden'); composer.removeAttribute('aria-hidden');
        const message = composer.querySelector('.gemini-transformer__status');
        if (message) {
          message.textContent = 'Your portrait is saved, but its preview could not load. Please reopen it from Saved portraits.';
          message.classList.add('gemini-transformer__status--error');
        }
        window.BellissimaPortraitEntry?.finish();
        root.dispatchEvent(new CustomEvent('uk:portrait-presented', {bubbles:true}));
        return;
      }
      if (revision !== readyRevision || root.dataset.view !== 'ready' || readyIdentity !== identity) return;
      // URL entry preserves the browser's position, including back/forward restoration.
      const positionReady = source !== 'saved-entry' && source !== 'emailed-entry' && source !== 'email-pending' && source !== 'demo-entry' && source !== 'amended' && !root.ukPortraitOptionalOffer?.isHolding();
      const image = $('[data-uk-art]');
      if (positionReady) {
        const html = document.documentElement;
        html.classList.add('uk-portrait-positioning');
        positionAtTop();
        // Let Bellissima's sticky header adopt its final height while the progress cover remains.
        await twoFrames();
        html.classList.remove('uk-portrait-positioning');
      }
      if (revision !== readyRevision || root.dataset.view !== 'ready') return;
      // Position under the existing progress cover, then reveal and dismiss together.
      delete root.dataset.revealing; root.dataset.settled = 'true';
      order.disabled = demo || !portrait || !selected.available || root.dataset.ukBusy === 'true';
      window.BellissimaPortraitEntry?.finish();
      root.dispatchEvent(new CustomEvent('uk:portrait-presented', {bubbles:true}));
      if (positionReady && interaction === interactionRevision) {
        image.setAttribute('tabindex', '-1'); image.focus({preventScroll:true});
      }
    }
    function restart() {
      readyIdentity = ''; readyRevision++; savedEntryPending = false;
      delete root.dataset.revealing; delete root.dataset.settled;
      window.BellissimaPortraitEntry?.finish();
      demo = false; root.dataset.view = 'upload'; $('.uk-portrait__upload').hidden = false; $('.uk-portrait__ready').hidden = true;
      syncExpress();
      composer.classList.remove('gemini-transformer--hidden'); composer.removeAttribute('aria-hidden');
      $('[data-uk-order-status]').textContent = '';
      if (file) file.value = '';
      composer.querySelector('.gemini-transformer__actions')?.classList.remove('uk-show-retry');
      root.scrollIntoView({behavior:'smooth',block:'start'});
    }
    $('[data-uk-demo]')?.addEventListener('click', () => showReady(true));
    $('[data-uk-demo-upload]').addEventListener('click', () => { restart(); file?.click(); });
    file?.addEventListener('change', () => {
      if (!file.files?.length) return;
      readyIdentity = ''; readyRevision++; savedEntryPending = false;
      delete root.dataset.revealing; delete root.dataset.settled;
      demo = false; portrait = ''; order.disabled = true;
      syncExpress();
      composer.querySelector('.gemini-transformer__actions')?.classList.remove('uk-show-retry');
      // Existing engine's file-change handler runs first and owns validation and generation.
      if (generate && !generate.disabled) generate.click();
    });
    const status = composer.querySelector('.gemini-transformer__status');
    // The native style preview stops when this adapter takes ownership.
    // Clear only its pending startup message; retain real errors/recovery notices.
    if (status?.textContent === 'Preparing style preview.') { status.textContent = ''; status.hidden = true; }
    function syncRetryAction() {
      const photo = file?.files?.[0];
      const canRetry = root.dataset.view === 'upload' && Boolean(photo) &&
        (!photo.type || /^image\//i.test(photo.type)) && !generate?.disabled &&
        status?.classList.contains('gemini-transformer__status--error');
      composer.querySelector('.gemini-transformer__actions')?.classList.toggle('uk-show-retry', Boolean(canRetry));
      if (generate) generate.textContent = canRetry ? 'Try again' : uploadActionText;
    }
    if (status) new MutationObserver(syncRetryAction).observe(status, {attributes:true,childList:true,subtree:true});
    if (generate) new MutationObserver(syncRetryAction).observe(generate, {attributes:true,attributeFilter:['disabled']});
    syncRetryAction();
    root.addEventListener('uk:portrait-ready', event => { showReady(false, event.detail?.source); });
    root.addEventListener('uk:portrait-restore-error', () => {
      savedEntryPending = false;
      render();
      window.BellissimaPortraitEntry?.finish();
    });
    document.addEventListener('change', event => {
      if (event.target === master && !syncing) {
        // A late native initializer must not replace the emailed choice while its artwork loads.
        if (restoringVariant) { syncNative(); render(); return; }
        const nativeVariant = variants.find(v => String(v.id) === master.value);
        if (nativeVariant) {
          selected = nativeVariant; finish = finishOf(selected); size = sizeOf(selected);
          if (frameKeys.includes(finish)) preferredFrame = finish;
          render();
        }
      }
    });
    order.addEventListener('click', () => {
      if (order.disabled || root.dataset.ukBusy === 'true' || demo || !portrait || !selected.available || urlInput()?.value !== portrait) return;
      if (!syncNative()) return;
      if (nativeOrder.disabled) { $('[data-uk-order-status]').textContent = 'This option is unavailable. Please choose another size or finish.'; return; }
      nativeOrder.click();
    });
    // Keep any existing cart validation message visible beside the new order button.
    new MutationObserver(() => {
      const message = form.querySelector('.errors, .product-form__error-message, [role="alert"]');
      if (message?.textContent.trim()) $('[data-uk-order-status]').textContent = message.textContent.trim();
    }).observe(form, {childList:true,subtree:true,characterData:true});
    root.ukPortraitPresentation = {
      positionAtTop,
      state: () => ({portrait, demo, variantId: String(selected.id), ready: root.dataset.view === 'ready' && root.dataset.settled === 'true'}),
      busy: value => {
        if (!value && restoringVariant) { syncNative(); restoringVariant = null; }
        root.dataset.ukBusy = String(Boolean(value)); render();
      },
      selectVariant: (id, restore = false) => {
        const next = variants.find(v => String(v.id) === String(id));
        if (!next) return false;
        if (restore) restoringVariant = next;
        selected = next; finish = finishOf(selected); size = sizeOf(selected);
        if (frameKeys.includes(finish)) preferredFrame = finish;
        const synced = syncNative(); render(); return synced;
      }
    };
    root.dataset.initialized = 'true';
    if (new URLSearchParams(location.search).get('uk_preview')) {
      // A missing secondary asset must not trap an emailed-link visitor behind the cover.
      setTimeout(() => {
        if (root.dataset.actionsInitialized === 'true') return;
        root.dataset.linkRestoreFailed = 'true';
        const message = composer.querySelector('.gemini-transformer__status');
        if (message) {
          message.hidden = false;
          message.textContent = 'Your preview link could not load. Please reload the page or contact us for help.';
          message.classList.add('gemini-transformer__status--error');
        }
        root.dispatchEvent(new CustomEvent('uk:portrait-restore-error', {bubbles:true}));
        window.BellissimaPortraitEntry?.finish();
      }, 12000);
    }
    window.BellissimaPortraitEntry?.claim?.();
    // All markup and handlers exist now. Like Pop, restore saved state during parsing, before first reveal.
    root.dispatchEvent(new CustomEvent('uk:portrait-ui-initialized', {bubbles:true}));
    root.ukPortraitGate?.restore();
    if (new URLSearchParams(location.search).get('portrait_ui_demo') === '1' && !savedEntryPending) showReady(true, 'demo-entry');
    else if (!savedEntryPending) {
      render();
      const revision = readyRevision;
      settlePresentation($('[data-uk-example]')).catch(() => {}).then(() => {
        if (revision === readyRevision && root.dataset.view === 'upload') window.BellissimaPortraitEntry?.finish();
      });
    }
    return true;
  };
  // Loaded synchronously after the complete native form, rather than building a second page at DOMContentLoaded.
  if (!start() && document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
})();
